import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=c194bcfc&scoped=true"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"
import style0 from "./ProjectCreate.vue?vue&type=style&index=0&id=c194bcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c194bcfc",
  null
  
)

export default component.exports